module.exports = __webpack_public_path__ + "M-DCH2OwfI3May0Kx/tandc_icon.svg";